'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.applyTransition = applyTransition;
exports.unapplyTransition = unapplyTransition;
exports.reduceTransition = reduceTransition;
function applyTransition() {
    var speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    if (!this.config.options.fade && (this.reducedAnimationApplied || this.animationUnapplied)) {
        var animSpeed = this.config.options.speed * speed;
        animSpeed = Math.min(Math.max(animSpeed, this.config.options.minSpeed), this.config.options.speed);
        this.elements.track.style.transition = 'transform ' + animSpeed + 'ms ' + this.config.options.ease;
        this.reducedAnimationApplied = false;
        this.animationUnapplied = false;
    }
}

function unapplyTransition() {
    if (!this.config.options.fade) {
        this.elements.track.style.transition = 'none';
        this.animationUnapplied = true;
    }
}

function reduceTransition() {
    if (!this.config.options.fade) {
        this.elements.track.style.transition = 'transform 1ms linear';
        this.reducedAnimationApplied = true;
    }
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/src/slider/animations.js
// module id = ./resources/assets/js/src/slider/animations.js
// module chunks = 0